var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlobBottomLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 142,
    viewBox: "0 0 201 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.081 2.96445C125.176 1.07254 156.497 -5.87426 176.843 11.5469C199.363 30.8293 205.928 62.0589 197.414 88.8747C189.338 114.313 164.282 132.992 135.909 140.475C112.024 146.775 90.3937 132.093 67.6086 123.11C43.0847 113.441 10.3944 110.575 2.2058 87.7612C-6.33319 63.9714 11.3227 39.0277 31.0878 21.3621C48.2313 6.03978 72.9064 4.59238 97.081 2.96445Z",
    fill: "#DEEBF8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobBottomLeft);
export default __webpack_public_path__ + "static/media/blob-bottom-left.0d98dabef52c2a477c352fc184ab055c.svg";
export { ForwardRef as ReactComponent };